/* ========================================================================
   Videos
 ========================================================================== */

var app = app || {};

app.videos = (function () {
  'use strict';

  function init() {
    const videos = document.querySelectorAll('[data-video]:not([data-video-initialized])');

    if (typeof Vimeo === 'undefined') return;
    if (videos.length === 0) return;

    videos.forEach((video) => {
      initPlayer(video);
    });
  }

  function initPlayer(video) {
    const preview = video.querySelector('[data-video-preview]');
    const button = video.querySelector('[data-video-button]');
    const loading = video.querySelector('[data-video-loading]');
    const iframe = video.querySelector('iframe');

    button.addEventListener('click', (event) => {
      event.preventDefault();

      iframe.style.visibility = 'visible';
      button.classList.add('is-loading');
      loading.classList.add('is-loading');

      var player = new Vimeo.Player(iframe);

      player.on('loaded', function () {
        // console.log('loaded');

        // start player
        player
          .play()
          .then(function () {
            preview.remove();

            // DATALAYER
            app.dataLayer.pushEvent('videoBekeken', {
              pageUrl: window.location.pathname,
              option: video.dataset.videoTitle,
            });
          })
          .catch(function (error) {
            preview.remove();
            console.log('Vimeo API error: ' + error.name);
          });
      });
    });

    video.dataset.videoInitialized = true;
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
